const BASE_Z_INDEX = 1002

export const USER_PROFILE_Z_INDEX = {
  surface: BASE_Z_INDEX,
  contextMenu: BASE_Z_INDEX + 1,
  tooltip: BASE_Z_INDEX + 2
} as const
